import React, { useEffect, useState } from "react";
import {Container ,Input } from "reactstrap";
import { Formik,Form,Field } from "formik";
import { Loading } from "../../share/loading";
// import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import { th as thBuddhist } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {TiTick} from "react-icons/ti"
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";



export function ProposedToTheSubCommittee4EditViewComponent () {
    registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
    const range = (start, end) => {
        return new Array(end - start).fill().map((d, i) => i + start);
    };
    const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ];
    const years = range(1963, getYear(new Date()) + 8, 1);
    // registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
    
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [meetingDate, setMeetingDate] = useState("")
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingNo, setMeetingNo] = useState("")
    // console.log("meetingNo", meetingNo)
    // console.log("meetingYear", meetingYear)
    // console.log("meetingDate", meetingDate)

    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    // console.log("meetingYearselect",meetingYearSelect)
    const [meetingNoSelect, setMeetingNoSelect] = useState([])
    // console.log("data",data)

   const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
    // const year = format(date, 'yyyy', { locale: th });
    return (
      <div className="react-datepicker__custom-header">
        <div className="react-datepicker__custom-header-left">
          <button
            type="button"
            className="react-datepicker__navigation react-datepicker__navigation--previous"
            aria-label="previous month"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
          </button>
        </div>
        <div className="react-datepicker__custom-header-center">
          {/* {format(date, 'MMMM', { locale: th })} {Number(year) + 543} */}
          <select
              value={thaiMonths[getMonth(date)]}
              onChange={({ target: { value } }) =>
              changeMonth(thaiMonths.indexOf(value))
              }
          >
              {thaiMonths.map(option => (
              <option key={option} value={option}>
                  {option}
              </option>
              ))}
          </select>
      
          <select
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
          >
              {years.map(option => (
              <option key={option} value={option}>
                  {Number(option)+543}
              </option>
              ))}
          </select>
        </div>
        <div className="react-datepicker__custom-header-right">
          <button
            type="button"
            className="react-datepicker__navigation react-datepicker__navigation--next"
            aria-label="next month"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
          </button>
        </div>
      </div>
    );
  };
    useEffect(() => {
        async function GetMeetingForSelect () {
          setLoading(true)
          try{
            let res = await fetch(`api/ProposalBorrow/getMeetingNoSelectTest`);
            let resJson = await res.json();
            // console.log(resJson.dataenum)
            setMeetingNoSelect(resJson.dataenum);
            // console.log("borrowInfo", resJson.dataenum);
          } catch(e) {
            // console.log("err =>",e)
    
          } finally {
            setLoading(false)
          }
        }
        GetMeetingForSelect ()
        
      },[])



    useEffect(() => {
        async function GetBorrowThree() {
            setLoading(true)
            try {
                let res = await fetch(`api/ProposalBorrow/GetProposalBorrow4ViewDataedit/${meetingNo}/${meetingYear}/${meetingDate}`);
                let resJson = await res.json();
                // console.log(resJson.dataenum)
                setData(resJson.dataenum);
                // console.log("borrowInfo", resJson.dataenum);
            } catch (e) {
                // console.log("err =>", e)

            } finally {
                setLoading(false)
            }
        }
        GetBorrowThree()
    }, [meetingNo, meetingYear, meetingDate])

    const fromInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: ""
    }
    // const validateSchema = Yup.object().shape({

    // })

  

    return(
        <Formik
        initialValues={fromInitialValues}
        enableReinitialize
            >
                {({values,errors,touched,setFieldValue,handleBlur,handleChange}) => {

                    async function getYearForSelect (e) {
                        let postData = new FormData()
                        postData.append("meetingNo",e.target.value)
                        // console.log("meetingNo",e.target.value)
                        try{
                            let res = await fetch("api/ProposalBorrow/getMeetingYearSelectTest",{
                            method:"POST",
                            body:postData
                        })
                        let resJson = await res.json()
                        // console.log("resjson",resJson.dataenum)
                        setMeetingYearSelect(resJson.dataenum)
                        }catch(e) {
                        // console.log("err",e)
                        }
                    }
                    return(
                        <Container>
                            {!loading ? (
                            <>
                                <div className="d-flex justify-content-center align-items-center mb-2">
                                    <Form
                                        className="d-flex align-items-center justify-content-end w-75"
                                        // onSubmit={formik.handleSubmit}
                                        autoComplete="off"
                                    >
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ครั้งที่</span>
                                            <Input
                                                name="meetingNo"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e)=> {
                                                    handleChange(e)
                                                    getYearForSelect(e)
                                                    setMeetingNo(e.target.value)
                                                    }}
                                                onBlur={handleBlur}
                                                value={values.meetingNo}
                                                >
                                                    <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                    </option>
                                                    {meetingNoSelect.map((item,k) => (
                                                    <option key={k} value = {item.meetingNo}>
                                                        {item.meetingNo}
                                                    </option>
                                                    ))}
                                                </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-75 text-center">ปี</span>
                                            <Input
                                                name="meetingYear"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e)=> {
                                                    handleChange(e)
                                                    setMeetingYear(e.target.value)
                                                    }}
                                                onBlur={handleBlur}
                                                value={values.meetingYear}
                                                >
                                                    
                                                    <option defaultValue={"กรุณาเลือก"}>
                                                    กรุณาเลือก
                                                    </option>
                                                    {meetingYearSelect.map((year,i) => (
                                                    <option key={i} value ={year.meetingYear}>
                                                        {year.meetingYear}
                                                    </option>
                                                    ))}
                                                </Input>

                                        </div>
                                        <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                                            <span className="w-50 text-center">วันที่</span>
                                            <Field name="meetingDate">
                                                {({field, meta, form}) => {
                                                const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                                // console.log("select Data =>", selectedDate)
                                                const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null; 
                                                const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null; 
                                                
                                                
                                                return(
                                                    <DatePicker
                                                    selected={selectedDate}
                                                    locale="th-buddhist"
                                                    showIcon
                                                    calendarClassName="thai-buddhist"
                                                    dateFormat="dd MMMM yyyy"
                                                    value={formattedDate}
                                                    isClearable={true}
                                                    placeholderText="กรุณาเลือก"
                                                    renderCustomHeader={renderCustomHeader}
                                                    onChange={(date) => {
                                                        if (date instanceof Date && !isNaN(date)) {
                                                            const year = date.getFullYear();
                                                            const month = String(date.getMonth() + 1).padStart(2, '0');
                                                            const day = String(date.getDate()).padStart(2, '0');
                                                            const formattedDate = `${year}-${month}-${day}`;
                                                            // console.log("format",typeof(formattedDate))
                                                            form.setFieldValue(field.name, formattedDate);
                                                            setMeetingDate(formattedDate)
                                                        } else {
                                                            form.setFieldValue(field.name, "");
                                                        }
                                                    }}
                                                    customInput={
                                                        <Input
                                                        type="text"
                                                        className={
                                                            touched.meetingDate && errors.meetingDate
                                                            ? "input-error rounded-pill text-center input-color"
                                                            : "rounded-pill text-center input-color"
                                                        }
                                                        value={formattedDate}
                                                        onChange={() => {}}
                                                        onBlur={field.onBlur}
                                                        />
                                                    }
                                                    />
                                                )                                
                                                }}
                                            </Field>

                                        </div>
                                    </Form>
                                </div>
                                <div className="outer-wrapper">
                                <div className="table-wrapper">
                                    <table>
                                        <thead>
                                            <tr>
                                            <th rowSpan="3">ลำดับ</th>
                                            <th rowSpan="3">เลขที่คำขอ</th>
                                            <th rowSpan="3">ผู้ขอกู้</th>
                                                            <th colSpan="2">ประเภทกู้ยืม</th>
                                            <th rowSpan="3">ประเภทกิจการ</th>
                                                            <th rowSpan="3">จำนวนลูกจ้างทั้งสิ้น(คน)</th>
                                                            <th colSpan="10">รายละเอียดกู้ยืม</th>
                                            <th colSpan="2">หลักประกัน(บุคคลค้ำประกัน)</th>
                                            <th rowSpan="3">หน่วยงานที่รับคำขอกู้ยืมเงิน</th>
                                            </tr>
                                            <tr>
                                                    <th rowSpan="2">ผู้ดำเนินการทดสอบ</th>
                                                    <th rowSpan="2">ผู้ประกอบกิจการ</th>
                                                    <th colSpan="2">การดำเนินการทดสอบ</th>


                                                    <th rowSpan="2">สาขาอาชีพ</th>
                                                    <th rowSpan="2">สาขา</th>
                                                    <th rowSpan="2">ระดับ</th>
                                                    <th rowSpan="2">ระยะเวลาฝึกอบรม (ชั่วโมง)</th>
                                                    <th rowSpan="2">วันที่เริ่มฝึก</th>
                                                    <th rowSpan="2">วันที่จบการฝึก</th>
                                                    <th rowSpan="2">จำนวน (คน)</th>
                                                    <th rowSpan="2">รวมวงเงินที่ขอกู้ (บาท)</th>
                                                    <th rowSpan="2">ชื่อ-สกุล</th>
                                                    <th rowSpan="2">ตำแหน่ง</th>
                                                </tr>
                                                <tr>
                                                    <th >ทดสอบเอง</th>
                                                    <th >ส่งไปฝึก</th>
                                                    
                                                </tr>
                                        </thead>
                                        <tbody>
                                        {!data.length ? (
                                            <tr>
                                            <td className="text-center border-none" colSpan={9}>ไม่พบข้อมูล</td>
                                            </tr>
                                        ):(
                                        <>
                                            {data.map((item,i) => (
                                            <tr key={i}>
                                                <td>{i+1}</td>
                                                {/* เลขที่คำขอกู้ยืมเงิน */}
                                                <td>{item.borrowNumber}</td>
                                                {/* ชื่อผู้ขอกู้ยืม */}
                                                <td>{item.employee}</td>
                                                {/* ประเภทการสมัคร */}
                                                <td>{item.typeTrain ? <TiTick/> : "-"}</td>
                                            {/* ประเภทกิจการ */}
                                                <td>{item.typeComp ? <TiTick/> : "-"}</td>
                                                {/*ทุนจดทะเบียน  */}
                                                    <td>{item.businessType}</td>
                                                    <td className="text-center">{item.employeeAmount}</td>
                                                    {/*<td>{item.employeeAmount}</td>*/}
                                                    <td className="text-center">{item.lift ? <TiTick/> : "-"}</td>
                                                    <td className="text-center">{item.change ? <TiTick/> : "-"}</td>
                                                    <td>{item.lawOccupationName}</td>
                                                    <td>{item.testOccupationName}</td>
                                                    <td className="text-center">{item.stdLevelTname}</td>
                                                    <td>-</td>
                                                    <td>{item.startDate}</td>
                                                    <td>{item.endDate}</td>
                                                    <td className="text-center">{item.personTotal}</td>
                                                    <td className="text-center">{NumberWithCommas(item.amountLimit)}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.position}</td>
                                                    <td>{item.site}</td>
                                            </tr>

                                            ))} 
                                        </>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </>
                            ):(<Loading/>)}
                            
                        </Container>





                    )
                }}


        </Formik>

      
      

    )

}